import React from "react";

const Footer = () => {
	return (
		<div className="Footer">
			<footer>
				<p>
					<a
						href="https://github.com/SummerinTech/to-do-list-react"
						target="_blank"
						rel="noreferrer"
					>
						Open-source app{" "}
					</a>{" "}
					created by Summer Robinson
				</p>
			</footer>
		</div>
	);
};

export default Footer;
